<template lang="">
  <div>
    <div>
      <div class="lg:flex lg:items-center lg:justify-between lg:mx-12 mx-12">
        <div>
          <h2
            class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
          >
            Payments
          </h2>
        </div>
        <div class="flex justify-end lg:justify-end mt-4 min-w-0 w-full">
          <div class="gap-3 w-min flex flex-col justify-end md:flex-row lg:mt-0 lg:ml-4" >
            <label class="m-auto">From:</label>
            <date-time-picker class=" md:mx-2" v-model="dateFrom" format="dd-LL-yyyy HH:mm:ss" :initial-view-date="this.dateFrom"></date-time-picker>
            <label class="m-auto">To:</label>
            <date-time-picker class=" md:mx-2" v-model="dateTo" format="dd-LL-yyyy HH:mm:ss" :initial-view-date="this.dateTo"></date-time-picker>
            <button class="appearance-none block  bg-woo shadow text-white rounded py-2 px-4  leading-tight" @click="getPayments">Search</button>
          </div>
        </div>
        <div class="justify-center flex lg:mt-0 lg:ml-4">
          <span class="sm:ml-3">
            <vue-excel-xlsx
              class="bg-green-500 hover:bg-gray-400 text-white font-bold py-2 mt-4 px-4 rounded inline-flex items-center shadow-sm text-sm"
              :data="data"
              :columns="columns"
              :file-name="'Payments ' + (new Date()).getTime()"
              :file-type="'xlsx'"
              :sheet-name="'sheetname'"
            >
              Export
            </vue-excel-xlsx>
          </span>
        </div>
      </div>
      
      <!-- Data Table -->
      <GoodTable
        :name="'Payments'"
        :rows="data"
        :columns="columns"
        :line-numbers="true"
      />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Http, { ENDPOINTS } from "../request";
import GoodTable from "../components/GoodTable.vue";
import "vue-toastification/dist/index.css";
import VueExcelXlsx from "vue-excel-xlsx";
import router from "../router";
import DateTimePicker from 'vue-vanilla-datetime-picker';
import  '../../node_modules/vue-vanilla-datetime-picker/dist/DateTimePicker.css'

Vue.use(VueExcelXlsx);
export default {
  components: {
    DateTimePicker,
    GoodTable,
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
      exportColumns: null,
      data: null,
      applications: this.$store.state.application,
      columns: [
        {
          label: "Transaction Date",
          field: "transactionDate",
        },
        {
          label: "Transaction Id",
          field: "transactionId",
          type: "number",
          filterOptions: {
            enabled: true,
            placeholder: "Search by Transaction Id", 
            filterValue: "", 
          }
        },
        {
          label: "Description",
          field: "description",
          filterOptions: {
            enabled: true,
            placeholder: "Search by Description", 
            filterValue: "", 
          }
        },
        {
          label: "Payer Account Id",
          field: "payerAccountId",
          type: "number",
          filterOptions: {
            enabled: true,
            placeholder: "Search by Payer Account Id", 
            filterValue: "", 
          }
        },
        {
          label: "Payer Name",
          field: "payerName",
          filterOptions: {
            enabled: true,
            placeholder: "Search by Payer Name", 
            filterValue: "", 
          }
        },

        {
          label: "Payer Phone Number",
          field: "payerPhoneNumber",
          type: "number",
          filterOptions: {
            enabled: true,
            placeholder: "Search by Payer Phone Number", 
            filterValue: "", 
          }
        },

        {
          label: "Amount",
          field: "amount",
          type: "number",
          filterOptions: {
            enabled: true,
            placeholder: "Search by Amount", 
            filterValue: "", 
          }
        },
      ],
    };
  },
  created() {
    this.filtersHandler();
  },
  methods: {
    filtersHandler() {
      this.dateTo = new Date();
      this.dateFrom = new Date(this.dateTo - 1);
      this.dateTo.setHours(23,59,59,59);
      this.dateFrom.setHours(0,0,0,0);

      this.getPayments();
    },
    getPayments() {
      Http()
        .post(ENDPOINTS.payments, {
          dateTo: new Date(this.dateTo).getTime(),
          dateFrom: new Date(this.dateFrom).getTime(),
        })
        .then((response) => {
          if (response.status) {
            this.data = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
  },
};
</script>
<style lang=""></style>
